export function trackGameStart(gameName, level) {
  window.gtag("event", "game_start", {
    game_name: gameName,
    level: level,
    timestamp: Date.now(),
  });
}
